<template>
    <div v-if="showDialog" class="insure-notice-container" @click="handleClose">
        <div class="inner-box">
            <img class="insure-header" src="../../assets/dialog/insure-notice-head.png" alt="">
            <div class="text-box">
                <div>尊敬的客户，</div>
                <div>您的账户<strong class="text-orange">余额不足</strong>以支付未来3天保费，<strong>请尽快充值！</strong></div>
            </div>
            <div class="white-box">
                <div class="flex-box border-b">
                    <div class="text-gray">未来3天预估扣费</div>
                    <div>¥ {{ feeData.threeDayNeedCostFee }}</div>
                </div>
                <div class="flex-box between border-b">
                    <div class="text-gray">当前账户余额</div>
                    <div>¥ {{ feeData.currentBalance }}</div>
                </div>
                <div class="flex-box between">
                    <div class="text-gray">差额</div>
                    <div class="text-red">¥ {{ feeData.threeDayDiff }}</div>
                </div>
            </div>
            <div class="btn" @click="handleClose">我已知晓</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        feeData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            showDialog: false
        }
    },
    watch: {
        show: {
            handler(newval) {
                this.showDialog = newval
            },
            immediate: true
        },
        showDialog(newval) {
            this.$emit('update:show', newval)
        }
    },
    methods: {
        handleClose() {
            this.showDialog = false
        }
    }
}
</script>
<style lang="stylus" scoped>
.insure-notice-container
    position fixed
    left 0
    top 0
    width 100vw
    height 100vh
    overflow auto
    background rgba(0, 0, 0, 0.7)
    z-index 100000
    display flex
    align-items center
    justify-content center
    .inner-box
        width 410px
        border-radius 20px
        border-radius: 18px;
        background: radial-gradient(93% 93% at 131% 73%, #f9ccdf 0%, #eff9ff00 100%, #fffdef00 100%), radial-gradient(49% 49% at 26% -12%, #a8c5ff 0%, #f6fffd00 100%), radial-gradient(47% 47% at -14% -12%, #b5efff 0%, #f6fffd00 100%), linear-gradient(180deg, #ffffff 0%, #fff4ef 100%);
        font-size: 16px
    .insure-header
        width 348px
        height auto
        margin -24px auto 0
        display block
    .text-box
        margin-top -70px
        margin-left 24px
    .white-box
        width 265px
        background #fff
        border-radius 8px
        padding 0 15px
        margin 16px auto 16px
    .border-b
        border-bottom 1px solid #f4f4f4
    .flex-box
        display flex
        justify-content space-between
        padding 16px 0
        font-size 14px
    .text-gray
        color #86878C
    .text-red
        color #FF330A
    .text-orange
        color #FF680A
    .btn
        width 160px
        height 36px
        font-weight bold
        line-height 36px
        border-radius 20px
        margin 0 auto 20px
        cursor pointer
        background linear-gradient(90deg, #ff680a 0%, #ffc70f 100%)
</style>
